// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__P7n0o"};